import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import TraitAccordion from 'on_web/components/shared/CustomAccordion/TraitAccordion';

export default function TraitAccordionList(props) {
  const useStyles = makeStyles(() => ({
    root: {
      flexGrow: 1,
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Grid container direction="column">
          {props.traits.map((trait, ix) => {
            return (
              <Grid item key={ix}>
                <Box my={'1.5px'}>
                  <TraitAccordion defaultExpanded={ix === 0} trait={trait} />
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
}
